var SERVER_URL  = "https://pmkjsieit.herokuapp.com"
if (process.env.NODE_ENV === "production")
	SERVER_URL = "https://pmkjsieit.herokuapp.com";
else	
	SERVER_URL = "https://pmkjsieit.herokuapp.com";
export default SERVER_URL;